@import "../../containers/styles.module.scss";

.optionChoice {
  display: flex;
  border: none;
  background-color: inherit;
  outline: none;
  width: auto;
  font-weight: bold;
  padding: 1rem;
  width: 100%;
  outline-color: none;
  align-items: center;
}

.optionChoice:hover {
  cursor: pointer;
}

.optionsContainer {
  margin: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.progressBar {
  display: flex;
}

.container {
  padding-bottom: calc(100vh - 768px);
}

.mainContainer {
  display: flex;
}
.legendContainer {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.mainSection {
  display: flex;
  justify-content: space-between;
}

@media (max-width: 900px) {
  .mainSection {
    flex-direction: column;
    display: flex;
    align-items: end;
  }
  .legendContainer {
    height: 130px;
  }
  .mainContainer {
    flex-direction: column;
  }
  .testButtons {
    width: 100%;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
}

.question {
  color: gray;
  font-size: 16px;
  padding-bottom: 1rem;
}

.testButtons {
  width: 100%;
  justify-content: space-between;
  display: flex;
}
